import * as React from 'react'

import {
  BellIcon,
  BellRingIcon,
  CirclePlusIcon,
  CircleUserRoundIcon,
  FilesIcon,
  FlagIcon,
  HouseIcon,
  MessageSquareTextIcon,
  ScanQrCodeIcon,
  TruckIcon,
  UsersIcon,
} from 'lucide-react'

import mobileRoutes from '~/client/src/mobile/constants/mobileRoutes'
import * as Icons from '~/client/src/shared/components/Icons'
import { GenericWorkflowIcon } from '~/client/src/shared/components/WorkflowTypeIcon/WorkflowIconGroups'

import './SectionIcon.scss'

const ICON_SIZE = 22

interface IProps {
  route: string
}

export default class SectionIcon extends React.Component<IProps> {
  public render() {
    return (
      <div className="section-icon-container tw:flex">{this.renderIcon()}</div>
    )
  }

  private renderIcon() {
    switch (this.props.route) {
      case mobileRoutes.HOME:
        return <HouseIcon size={ICON_SIZE} className="tw:text-primary" />
      case mobileRoutes.DELIVERIES:
        return <TruckIcon size={ICON_SIZE} className="tw:text-primary" />
      case mobileRoutes.USERS_DIRECTORY:
        return <UsersIcon size={ICON_SIZE} className="tw:text-foreground" />
      case mobileRoutes.USER_PROFILE:
        return (
          <CircleUserRoundIcon
            size={ICON_SIZE}
            className="tw:text-foreground"
          />
        )
      case mobileRoutes.NOTIFICATIONS:
        return <BellIcon size={ICON_SIZE} className="tw:text-primary" />
      case mobileRoutes.FORMS:
        return <GenericWorkflowIcon className="tw:flex-none!" />
      case mobileRoutes.DOCUMENTS:
        return <FilesIcon size={ICON_SIZE} className="tw:text-primary" />
      case mobileRoutes.PROJECTS:
        return <FlagIcon size={ICON_SIZE} className="tw:text-primary" />
      case mobileRoutes.CHAT:
        return (
          <MessageSquareTextIcon size={ICON_SIZE} className="tw:text-primary" />
        )
      case mobileRoutes.ADD_TEAMMATE:
        return (
          <CirclePlusIcon size={ICON_SIZE} className="tw:text-foreground" />
        )
      case mobileRoutes.QR_CODES:
        return (
          <ScanQrCodeIcon size={ICON_SIZE} className="tw:text-foreground" />
        )
      case mobileRoutes.NOTIFICATION_SETTINGS:
        return <BellRingIcon size={ICON_SIZE} className="tw:text-foreground" />
      default:
        return <Icons.LogoDark className="row" />
    }
  }
}
